// extracted by mini-css-extract-plugin
export default {"root":"style_root__6sgP+","table":"style_table__49AuT"};